import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { PainStories } from './components/PainStories';
import { Transformation } from './components/Transformation';
import { TheSystem } from './components/TheSystem';
import { Bonuses } from './components/Bonuses';
import { ValueStack } from './components/ValueStack';
import { Qualifier } from './components/Qualifier';
import { PremiumUpsell } from './components/PremiumUpsell';
import { Guarantee } from './components/Guarantee';
import { ClosingContrast } from './components/ClosingContrast';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-pump-dark text-gray-100 font-sans selection:bg-pump-gold selection:text-pump-dark" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <PainStories data-id="element-3" />
      <Transformation data-id="element-4" />
      <TheSystem data-id="element-5" />
      <Bonuses data-id="element-6" />
      <ValueStack data-id="element-7" />
      <Qualifier data-id="element-8" />
      <PremiumUpsell data-id="element-9" />
      <Guarantee data-id="element-10" />
      <ClosingContrast data-id="element-11" />
      <Pricing data-id="element-12" />
      <Footer data-id="element-13" />
      <StickyCTA data-id="element-14" />
    </div>;
}